import { Tag } from "primereact/tag";

const ConfiguracionAsignacion = ({ asignacion, catalogo }) => {
  const catalogoTipos = Array.isArray(catalogo) ? catalogo : [];

const detalleItemTemplate = (item, tipo) => (
    <div
      key={item.id}
      className="flex flex-column gap-1 py-2 border-bottom-1 surface-border"
    >
      <div className="flex justify-content-between align-items-center gap-2">
        <span className="text-sm">
          {item.descripcion ?? "—"} 
          {/* ({[item.relacion, ].filter(Boolean).join(" · ")}) */}
        </span>
      </div>
      <div className="flex flex-wrap align-items-center gap-2">
        {/* Esquema de cantidad dinámica: se muestra el documento asignado al
            ítem; el estado consolidado/separado lo infiere el backend */}
        <Tag
          value={
            Number(item.agrupamiento) > 0
              ? `${tipo.descripcion} ${item.agrupamiento}`
              : "—"
          }
          severity={Number(item.agrupamiento) > 0 ? "info" : "secondary"}
          className="p-tag-sm"
        />
      </div>
    </div>
  );

  return (
    <div className="card mb-3">
      <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-2 mb-3">
        <h6 className="m-0 flex align-items-center gap-2 flex-wrap">
          <strong>Folio {asignacion.folio ?? asignacion.id}</strong>
          <span className="text-600 text-sm">· ID {asignacion.id}</span>
          <span>
            · <strong>{asignacion.empresa ?? "—"}</strong>
          </span>
        </h6>
        <span className="text-600 text-sm">
          Vigencia: {asignacion.desde ?? "—"} → {asignacion.hasta ?? "—"}
        </span>
      </div>
      <div className="grid">
        {catalogoTipos.length === 0 ? (
          <div className="col-12">
            <span className="text-500 text-sm">
              Catálogo de tipos de documento no disponible.
            </span>
          </div>
        ) : (
          catalogoTipos.map((tipo) => {
          const items = (
            Array.isArray(asignacion.detalles) ? asignacion.detalles : []
          ).filter((item) => item.cobro === tipo.descripcion);
          return (
            <div key={tipo.codigo ?? tipo.descripcion} className="col-12 lg:col-4">
              <div className="border-1 surface-border border-round p-2 h-full">
                <div className="flex justify-content-between align-items-center mb-2">
                  <span className="font-bold text-sm">{tipo.descripcion}</span>
                  <Tag
                    value={`${items.length} ítem${items.length === 1 ? "" : "s"}`}
                  />
                </div>
                {items.length === 0 ? (
                  <span className="text-500 text-sm">
                    Sin ítems configurados.
                  </span>
                ) : (
                  items.map((item) => detalleItemTemplate(item, tipo))
                )}
              </div>
            </div>
          );
        })
        )}
      </div>
    </div>
  );
};

export default ConfiguracionAsignacion;